import { render, staticRenderFns } from "./SimpleNumberView.vue?vue&type=template&id=9163ff78&scoped=true&"
import script from "./SimpleNumberView.vue?vue&type=script&lang=js&"
export * from "./SimpleNumberView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9163ff78",
  null
  
)

export default component.exports